import './App.css';
import React, { Suspense } from "react"
import { HashRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';

import ConfigurableLeaderboard from './configurable/ConfigurableLeaderboard';
import ConfigurableOverlay from './configurable/ConfigurableOverlay';

import Leaderboard2R from './leaderboards/2r/Leaderboard2R';
import LeaderboardBackToOG from './leaderboards/back-to-og/LeaderboardBackToOG';
import LeaderboardBackToOGV2 from './leaderboards/back-to-og-v2/LeaderboardBackToOGV2';
import LeaderboardBackToOGV3 from './leaderboards/back-to-og-v3/LeaderboardBackToOGV3';
import LeaderboardCDFSly from './leaderboards/cdf-sly/LeaderboardCDFSly';
import LeaderboardCoupeDeFrance from './leaderboards/coupe-de-france/LeaderboardCoupeDeFrance';
import LeaderboardCtn from './leaderboards/ctn/LeaderboardCtn';
import LeaderboardErazer from './leaderboards/erazer/LeaderboardErazer';
import LeaderboardErazerV2 from './leaderboards/erazer/LeaderboardErazerV2';
import LeaderboardErazerCumulative from './leaderboards/erazer/LeaderboardErazerCumulative';
import LeaderboardErazerCumulativeV2 from './leaderboards/erazer/LeaderboardErazerCumulativeV2';
import LeaderboardErazerCumulativeV3 from './leaderboards/erazer/LeaderboardErazerCumulativeV3';
import LeaderboardJolavanilleArenaSolo from './leaderboards/jolavanille/LeaderboardJolavanilleArenaSolo';
import LeaderboardJolavanilleArenaDuo from './leaderboards/jolavanille/LeaderboardJolavanilleArenaDuo';
import LeaderboardLaSelection from './leaderboards/la-selection/LeaderboardLaSelection';
import LeaderboardLyost from './leaderboards/lyost/LeaderboardLyost';
import LeaderboardPP_RVJ from './leaderboards/pp-rvj/LeaderboardPP_RVJ';
import LeaderboardPlatformRivals from './leaderboards/platform-rivals/LeaderboardPlatformRivals';
import LeaderboardReddyshRoyale from './leaderboards/reddysh/LeaderboardReddyshRoyale';
import LeaderboardReload from './leaderboards/reload/LeaderboardReload';
import LeaderboardSlyHvK from './leaderboards/sly-hvk/LeaderboardSlyHvK';
import LeaderboardSolary from './leaderboards/solary/LeaderboardSolary';
import LeaderboardStizoCup from './leaderboards/stizo/LeaderboardStizoCup';
import LeaderboardStizoGW from './leaderboards/stizo/LeaderboardStizoGW';
import LeaderboardStizoVictory from './leaderboards/stizo/LeaderboardStizoVictory';
import LeaderboardTest from './leaderboards/test/LeaderboardTest';
import LeaderboardWolt from './leaderboards/wolt/LeaderboardWolt';
import LeaderBoardXinouCup from './leaderboards/xinou/LeaderBoardXinouCup';

import OverlayJoueursEnvie from './overlays/joueurs-envie/overlay_joueurs_envie';
import OverlayJoueursEnvieV2 from './overlays/joueurs-envie-v2/overlay_joueurs_envie_v2';
import OverlayBackToOG from './overlays/back-to-og/overlay_back_to_og';
import OverlayBackToOGV2 from './overlays/back-to-og-v2/overlay_back_to_og_v2';

import TwitchPolls from './TwitchPolls';

const StudioApp = React.lazy(() => import('./admin/StudioApp'));

function RedirectToFinaleRevenja() {
  const location = useLocation();
  return <Navigate to={`/finale_revenja_leaderboard${location.search}`} replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Suspense fallback={null}><StudioApp /></Suspense>}
        />
        <Route path="/leaderboard/:slug" element={<ConfigurableLeaderboard />} />
        <Route path="/overlay/:slug" element={<ConfigurableOverlay />} />
        <Route
          path="/admin"
          element={<Suspense fallback={null}><StudioApp /></Suspense>}
        />
        <Route
          path="/admin/:kind"
          element={<Suspense fallback={null}><StudioApp /></Suspense>}
        />
        <Route
          path="/admin/:kind/:slug"
          element={<Suspense fallback={null}><StudioApp /></Suspense>}
        />
        <Route path="/wolt_leaderboard" element={<LeaderboardWolt />} />
        <Route path="/reddysh_royale_leaderboard" element={<LeaderboardReddyshRoyale />} />
        <Route path="/stizo_leaderboard" element={<LeaderboardStizoCup />} />
        <Route path="/twitch_polls" element={<TwitchPolls />} />
        <Route path="/la_selection_leaderboard" element={<LeaderboardLaSelection />} />
        <Route path="/cdfsly_leaderboard" element={<LeaderboardCDFSly />} />
        <Route path="/ctn_leaderboard" element={<LeaderboardCtn />} />
        <Route path="/sly_hvk_leaderboard" element={<LeaderboardSlyHvK />} />
        <Route path="/reload_leaderboard" element={<LeaderboardReload />} />
        <Route path="/stizogw_leaderboard" element={<LeaderboardStizoGW />} />
        <Route path="/2r_leaderboard" element={<Leaderboard2R />} />
        <Route path="/solary_leaderboard" element={<LeaderboardSolary />} />
        <Route path="/lyost_leaderboard" element={<LeaderboardLyost />} />
        <Route path="/erazer_leaderboard" element={<LeaderboardErazer />} />
        <Route path="/erazer_leaderboard_v2" element={<LeaderboardErazerV2 />} />
        <Route path="/erazer_cumulative_leaderboard" element={<LeaderboardErazerCumulative />} />
        <Route path="/erazer_cumulative_leaderboard_v2" element={<LeaderboardErazerCumulativeV2 />} />
        <Route path="/erazer_cumulative_leaderboard_v3" element={<LeaderboardErazerCumulativeV3 />} />
        <Route path="/overlay_joueurs_envie" element={<OverlayJoueursEnvie />} />
        <Route path="/overlay_joueurs_envie_v2" element={<OverlayJoueursEnvieV2 />} />
        <Route path="/overlay_back_to_og" element={<OverlayBackToOG />} />
        <Route path="/overlay_back_to_og_v2" element={<OverlayBackToOGV2 />} />
        <Route path="/finale_revenja_leaderboard" element={<LeaderboardPP_RVJ />} />
        <Route path="/pp_revenja_leaderboard" element={<RedirectToFinaleRevenja />} />
        <Route path="/platform_rivals_leaderboard" element={<LeaderboardPlatformRivals />} />
        <Route path="/back_to_og_leaderboard" element={<LeaderboardBackToOG />} />
        <Route path="/back_to_og_leaderboard_v2" element={<LeaderboardBackToOGV2 />} />
        <Route path="/back_to_og_leaderboard_v3" element={<LeaderboardBackToOGV3 />} />
        <Route path="/coupedefrance_leaderboard" element={<LeaderboardCoupeDeFrance />} />
        <Route path="/stizo_victory_leaderboard" element={<LeaderboardStizoVictory />} />
        <Route path="/xinou_leaderboard" element={<LeaderBoardXinouCup />} />
        <Route path="/test_leaderboard" element={<LeaderboardTest />} />
        <Route path="/jolavanille_arena_solo_leaderboard" element={<LeaderboardJolavanilleArenaSolo />} />
        <Route path="/jolavanille_arena_duo_leaderboard" element={<LeaderboardJolavanilleArenaDuo />} />
      </Routes>
    </Router>
  );
}

export default App;
